export enum VehicleTypeEnum {
    Car = 1,
    LCV = 2,
    HGV = 3,
    Motorbike = 4,
    Caravan = 5,
    Motorhome = 6,
    All = 7
}
